'use client'

import React from 'react'
import parse from 'html-react-parser'
import LinkButton from '../link-button/link-button'

import styles from './styles/about-acko.module.css'
import Partners from './partners'
import UserInfo from './users-info'
import Roadmap from './road-map'

const AboutUs = ({ CMSData }) => {
  const {
    aboutHeading,
    ourStory,
    ourStoryDetails,
    roadmapVideo,
    partnerText1,
    partnerText2,
    partnerImages1,
    partnerImages2,
    partnerImages1Box2,
    partnerImages1Box3,
    partnerImages2Box2,
    partnerImages2Box3,
    activeUserHeading,
    activeUserCount,
    joinUsButton,
  } = CMSData

  return (
    <div className={styles.aboutContainer}>
      <div className={styles.aboutBlur}>{parse(aboutHeading)}</div>
      <Roadmap roadmapVideo={roadmapVideo} ourStory={ourStory} ourStoryDetails={ourStoryDetails} />
      <div className={styles.partnersDiv}>
        <Partners
          partnerText={partnerText1}
          partnerImages={partnerImages1}
          partnerImagesBox2={partnerImages1Box2}
          partnerImagesBox3={partnerImages1Box3}
          theme="white"
        />
        <Partners
          partnerText={partnerText2}
          partnerImages={partnerImages2}
          partnerImagesBox2={partnerImages2Box2}
          partnerImagesBox3={partnerImages2Box3}
          theme="blackBg"
        />
      </div>
      <UserInfo activeUserHeading={activeUserHeading} activeUserCount={activeUserCount} />
      <LinkButton
        eventName="join us button"
        btnText={joinUsButton.buttonText}
        btnStyle={joinUsButton.buttonStyle}
        btnLink={`/careers/${joinUsButton.buttonLink}`}
      />
    </div>
  )
}

export default AboutUs
